


























































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import EditDialog from "@/component/Crud/edit-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import {Form} from "element-ui";
import Product from "@/model/Product";
import ProductApi from "@/module/device/ProductApi";
import UnitApi, {UcreateForm, UeditForm, UpagingForm} from "@/module/thing/UnitApi";
import Unit from "@/model/Unit";
import IdColumn from "@/component/Table/id-column.vue";

@Component({
  components: {
    IdColumn,
    PaginationTable,
    RefreshButton,
    CreateDialog,
    EditDialog,
    DeleteDialog,
  },
})
export default class UnitView extends Vue {

  private api = Container.get(UnitApi)

  @Ref()
  private ptable!: PaginationTable

  private pqForm = new UpagingForm()

  private async getPaging() {
    return this.api.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  private rules =
      {
        name: [
          {required: true, message: '请输入名称', trigger: ['change', 'blur']},
        ],
        symbol: [
          {required: true, message: '请输入符号', trigger: ['change', 'blur']},
        ],
      }

  @Ref()
  private addDialog!: CreateDialog

  private addForm = new UcreateForm()

  @Ref()
  private addElForm!: Form

  private productApi = Container.get(ProductApi)

  private async beforeOpenAddDialog() {
    this.addElForm?.resetFields()
    await this.getProducts()
  }

  private products: Array<Product> = []

  private async getProducts() {
    this.products = await this.productApi.list()
  }

  private async addUnit() {
    const valid = await this.addElForm.validate()
    if (valid)
      await this.api.create(this.addForm)
  }

  private unit = new Unit()

  @Ref()
  private editDialog!: EditDialog

  private editForm: UeditForm = {
    id: this.unit.id,
    name: this.unit.name,
    symbol: this.unit.symbol
  }

  @Ref()
  private editElForm!: Form

  private handleEditClick(unit: Unit) {
    this.unit = unit
    this.editDialog.open()
  }

  private async beforeOpenEdiDialog() {
    this.editElForm?.resetFields()
    this.editForm.id = this.unit.id
    this.editForm.name = this.unit.name
    this.editForm.symbol = this.unit.symbol
  }

  private async editUnit() {
    const valid = await this.editElForm.validate()
    if (valid)
      await this.api.edit(this.editForm)
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private async handleDeleteClick(unit: Unit) {
    this.unit = unit
    this.deleteDialog.open()
  }

  private async deleteUnit() {
    await this.api.delete(this.unit.id)
  }
}
